import GeneralError from '@/pages/errors/general-error.tsx'
import { RouteObject } from 'react-router-dom'

export const omanagersRoutes: RouteObject[] = [
  {
    path: 'operations-manager',
    children: [
      {
        path: 'dashboard',
        lazy: async () => ({
          Component: (
            await import('../pages/operations-manager/dashboard/index.tsx')
          ).default,
        }),
      },
      {
        path: 'projects',
        lazy: async () => ({
          Component: (
            await import('../pages/operations-manager/projects/index.tsx')
          ).default,
        }),
      },
      // NEW: Messages
      {
        path: 'messages',
        lazy: async () => ({
          Component: (
            await import('../pages/operations-manager/messages/index.tsx')
          ).default,
        }),
      },
      // NEW: Team Management
      {
        path: 'team',
        lazy: async () => ({
          Component: (
            await import('../pages/operations-manager/team/index.tsx')
          ).default,
        }),
      },
      // NEW: Team sub-routes
      {
        path: 'team/leaders',
        lazy: async () => ({
          Component: (
            await import('../pages/operations-manager/team/leaders/index.tsx')
          ).default,
        }),
      },
      {
        path: 'team/assignments',
        lazy: async () => ({
          Component: (
            await import('../pages/operations-manager/team/assignments/index.tsx')
          ).default,
        }),
      },
      {
        path: 'resources',
        lazy: async () => ({
          Component: (
            await import('../pages/operations-manager/resources/index.tsx')
          ).default,
        }),
      },
      // NEW: Resource sub-routes
      {
        path: 'staff',
        lazy: async () => ({
          Component: (
            await import('../pages/operations-manager/staff/index.tsx')
          ).default,
        }),
      },
      {
        path: 'equipment',
        lazy: async () => ({
          Component: (
            await import('../pages/operations-manager/equipment/index.tsx')
          ).default,
        }),
      },
      // NEW: Schedule (replaces team-schedule)
      {
        path: 'schedule',
        lazy: async () => ({
          Component: (
            await import('../pages/operations-manager/schedule/index.tsx')
          ).default,
        }),
      },
      // NEW: Quality Control
      {
        path: 'quality',
        lazy: async () => ({
          Component: (
            await import('../pages/operations-manager/quality/index.tsx')
          ).default,
        }),
      },
      {
        path: 'quality/inspections',
        lazy: async () => ({
          Component: (
            await import('../pages/operations-manager/quality/inspections/index.tsx')
          ).default,
        }),
      },
      {
        path: 'quality/reports',
        lazy: async () => ({
          Component: (
            await import('../pages/operations-manager/quality/reports/index.tsx')
          ).default,
        }),
      },
      // EXISTING: Work Orders
      {
        path: 'work-orders',
        lazy: async () => ({
          Component: (
            await import('../pages/operations-manager/work-orders/index.tsx')
          ).default,
        }),
      },
      // EXISTING: Client Management
      {
        path: 'clients',
        lazy: async () => ({
          Component: (
            await import('../pages/operations-manager/clients/index.tsx')
          ).default,
        }),
      },
      // NEW: Client Requests (as sub-route or separate)
      {
        path: 'client-requests',
        lazy: async () => ({
          Component: (
            await import('../pages/operations-manager/client-requests/index.tsx')
          ).default,
        }),
      },
      // EXISTING: Analytics
      {
        path: 'analytics',
        lazy: async () => ({
          Component: (
            await import('../pages/operations-manager/analytics/index.tsx')
          ).default,
        }),
      },
      // NEW: Analytics sub-routes
      // {
      //   path: 'analytics/metrics',
      //   lazy: async () => ({
      //     Component: (
      //       await import('../pages/operations-manager/analytics/metrics/index.tsx')
      //     ).default,
      //   }),
      // },
      {
        path: 'compliance',
        lazy: async () => ({
          Component: (
            await import('../pages/operations-manager/compliance/index.tsx')
          ).default,
        }),
      },
      // EXISTING: Reports
      {
        path: 'reports',
        lazy: async () => ({
          Component: (
            await import('../pages/operations-manager/reports/index.tsx')
          ).default,
        }),
      },
      // EXISTING: Notifications
      {
        path: 'notifications',
        lazy: async () => ({
          Component: (
            await import('../pages/operations-manager/notifications/index.tsx')
          ).default,
        }),
      },
      // Operations Manager Settings
      {
        path: 'settings',
        lazy: async () => ({
          Component: (await import('../pages/operations-manager/settings/index.tsx')).default,
        }),
        errorElement: <GeneralError />,
      },
    ],
  },
]